<template>
  <v-container>
    <loader :isLoading="isLoading"></loader>
    <v-form ref="form" @submit.prevent="onSave">
      <v-card elevation="2">
        <v-card-text>
          <widget-component v-for="(widgetMetadata, index) in formData.widgets"
            :key="index"
            :widgetMetadata="widgetMetadata">
          </widget-component>
        </v-card-text>
      </v-card>
      <v-btn
        style="margin-top: 20px; "
        color="primary"
        type="submit"
      >
        Save
      </v-btn>
    </v-form>
    <!-- <form-component
      :formData="formData"
    >
    </form-component> -->
  </v-container>
</template>

<script>
import services from '../../../services';
import Loader from '../../../components/utilities/Loader.vue';
// import FormComponent from '../../../components/ui/FormComponent.vue';
import WidgetComponent from '../../../components/ui/WidgetComponent.vue';
import FormService from '../../../services/medical_registry/form.service';

const { biobankRegistry } = services;
const { boxTypeService } = biobankRegistry;

export default {
  name: 'BoxForm',
  components: {
    WidgetComponent,
    Loader,
  },
  props: {
    onSubmit: Function,
    isLoading: Boolean,
    box: Object,
  },
  data() {
    return {
      formData: {
        onSubmit: this.onSubmit,
        model: this.box,
        FormService,
        widgets: [
          {
            type: 'text',
            name: 'name',
            label: 'Box Number',
            value: '',
            counter: 100,
            maxLength: 100,
            rules: [
              (v) => !!v || 'Box Number is required',
            ],
          },
          {
            type: 'select',
            name: 'boxType',
            label: 'Box Type',
            items: [{ text: 'Not Applicable', value: null, disabled: true }],
            value: null,
            rules: [
              (v) => !!v || 'Box Type is required',
            ],
          },
          // Freezer id
          // If there is freezer Id then Auto populate Rack Number, Sliding rack, etc
          {
            type: 'textarea',
            name: 'description',
            label: 'Description',
            value: '',
            counter: 255,
            maxLength: 255,
            rules: [
              (v) => !!v || 'Description is required',
            ],
          },
        ],
      },
    };
  },
  async created() {
    const boxTypeWidget = this.formData.widgets.find((w) => w?.name === 'boxType');
    boxTypeWidget.items = (await boxTypeService.getList())
      .map((document) => ({ code: document.code, label: document.label }));

    this.formData.widgets.forEach((w) => {
      const widget = w;
      const getValue = (key) => {
        if (key.includes('date')) {
          return new Date(this.formData.model[key]);
        }
        return this.formData.model[widget?.name];
      };
      widget.value = getValue(widget?.name);
    });
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    async 'formData.widgets.1.value'(id) {
      const boxType = await boxTypeService.getOne(id);
      // create condition here for none BoxType
      const boxTypeWidget = this.formData.widgets.find((w) => w?.name === 'boxType');
      if (boxType.label === 'Cryobox') {
        console.log('selecting box type');
        const noOfColumn = {
          type: 'number',
          name: 'noOfColumn',
          label: 'No. of Column',
          value: this.formData.model?.noOfColumn || 0,
          min: 10,
          rules: [
            (v) => !!v || 'No. of Column is required',
          ],
        };
        const noOfRows = {
          type: 'number',
          name: 'noOfRows',
          label: 'No. of Rows',
          value: this.formData.model?.noOfRows || 0,
          min: 10,
          rules: [
            (v) => !!v || 'No. of Rows is required',
          ],
        };
        // this.formData.widgets.splice(1, 0, noOfColumn);
        this.formData.widgets = [
          ...this.formData.widgets.slice(0, 2), // Keep first two
          noOfColumn,
          noOfRows,
          ...this.formData.widgets.slice(2), // Append the rest
        ];
        boxTypeWidget.rules = [
          (v) => !!v || 'Box Type is required',
        ];
      } else {
        console.log('outside cryobox');
        this.formData.widgets = this.formData.widgets.filter(
          (w) => w?.name !== 'noOfColumn' && w?.name !== 'noOfRows',
        );
        boxTypeWidget.rules = [];
      }
    },
  },
  methods: {
    getFormDataJSON() {
      const data = FormService.dataAsJSON(this.formData);
      // eslint-disable-next-line no-underscore-dangle
      return data;
    },
    onSave() {
      if (this.$refs.form.validate()) {
        const dataChanges = this.getFormDataJSON();
        // If the boxType is 'none', then the columns and rows will be 0 also on saving
        if (dataChanges.boxType === 'none') {
          dataChanges.noOfColumn = 0;
          dataChanges.noOfRows = 0;
        }
        const data = Object.assign(this.box || {}, dataChanges);
        this.onSubmit(data);
      }
    },
  },
};
</script>
